import React, { useId } from 'react';

import { Label, LabeledControl, Paragraph, Radio, Text } from '@zillow/constellation-10';

type Props = {
  disabled?: boolean;
  onOption1Click: () => void;
  option1Content?: string;
  option1Header?: string;
  option1Selected: boolean;

  onOption2Click: () => void;
  option2Content?: string;
  option2Header?: string;
  option2Selected: boolean;

  optionsText?: string;
};

export default function OptionSelector({
  disabled,
  onOption1Click,
  onOption2Click,
  option1Selected,
  option2Selected,
  option1Header = 'Tenant',
  option2Header = 'Landlord',
  option1Content = 'Responsible for account set up and direct payments to specified service provider',
  option2Content = 'Responsible for account set up and will bill tenant separately',
  optionsText,
}: Props): JSX.Element {
  const radioGroupName = useId();
  return (
    <div>
      {optionsText && <Paragraph css={{ marginBottom: 'layout.tighter' }}>{optionsText}</Paragraph>}
      <LabeledControl
        size="lg"
        disabled={disabled}
        label={
          <Label>
            <span data-test="option1Header">{option1Header}</span>
            <br />
            <Text data-test="option1Content" css={{ color: 'text.subtle' }}>
              {option1Content}
            </Text>
          </Label>
        }
        control={
          <Radio name={radioGroupName} checked={option1Selected} onChange={onOption1Click} disabled={disabled} />
        }
      />
      <LabeledControl
        size="lg"
        disabled={disabled}
        label={
          <Label>
            <span data-test="option2Header">{option2Header}</span>
            <br />
            <Text data-test="option2Content" css={{ color: 'text.subtle' }}>
              {option2Content}
            </Text>
          </Label>
        }
        control={
          <Radio name={radioGroupName} checked={option2Selected} onChange={onOption2Click} disabled={disabled} />
        }
      />
    </div>
  );
}
